import { toDataURL } from "./Utils";

const RESOURCES_BASE_URL = process.env.REACT_APP_RESOURCES_BASE_URL;

export const uploadLogo = async (file, userEmail, token) => {
  const formData = new FormData();
  formData.append("files", file);
  formData.append("userEmail", userEmail);

  const res = await fetch(`${RESOURCES_BASE_URL}/logos`, {
    method: "POST",
    headers: { Authorization: token, "X-Access-Type": "API" },
    body: formData,
  });

  if (!res.ok) {
    throw new Error("Failed to upload logo");
  }
};

export const retrieveLogoLocation = async (userEmail, token) => {
  const url = `${RESOURCES_BASE_URL}/logos/by-user/${userEmail}`;
  const res = await fetch(url, {
    headers: { Authorization: token },
  });
  if (!res.ok) {
    throw new Error("Failed to retrieve logo location");
  }

  const location = await res.text();
  const urlTmp = await toDataURL(location, token);
  return urlTmp;
};
